import * as React from 'react';
var useEffect = React.useEffect,
    useRef = React.useRef,
    memo = React.memo;
export var HeadTitle = memo(function (_ref) {
  var title = _ref.title;
  var initialTitle = useRef(document.title);
  useEffect(function () {
    var previousTitle = initialTitle.current;
    document.title = title;
    return function () {
      document.title = previousTitle;
    };
  }, [title]);
  return null;
});